import { render, staticRenderFns } from "./C-3b__ProductList_FilterCategory.vue?vue&type=template&id=dcc78236&"
import script from "./C-3b__ProductList_FilterCategory.vue?vue&type=script&lang=js&"
export * from "./C-3b__ProductList_FilterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
